import { render } from "./FooterWrap.vue?vue&type=template&id=5425b2c0&scoped=true"
import script from "./FooterWrap.vue?vue&type=script&lang=js"
export * from "./FooterWrap.vue?vue&type=script&lang=js"

import "./FooterWrap.vue?vue&type=style&index=0&id=5425b2c0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5425b2c0"]])

export default __exports__